import { FC } from "react";
import { IconProps } from "@/common/icons/types";
import { LOGO_GRAY } from "@/styles/colorsJS";

export const ProfileIcon: FC<IconProps> = ({ color = LOGO_GRAY }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0002 9.99935C12.3013 9.99935 14.1668 8.13387 14.1668 5.83268C14.1668 3.5315 12.3013 1.66602 10.0002 1.66602C7.69898 1.66602 5.8335 3.5315 5.8335 5.83268C5.8335 8.13387 7.69898 9.99935 10.0002 9.99935Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
